import React, { FunctionComponent, useContext } from "react";
import { Button } from "@cmsgov/ds-medicare-gov";
import { AppStore } from "../app/store";
import { ActionType, UserLanguage } from "../@types";
import { sendTealiumEvent } from "../helpers/analytics";
import URI from "urijs";
import { withRouter, RouteComponentProps } from "react-router";

interface ToggleLanguageButtonProps {
  className?: string;
}

const ToggleLanguageButton: FunctionComponent<ToggleLanguageButtonProps &
  RouteComponentProps> = ({ className, history, location }) => {
  const { state, dispatch } = useContext(AppStore.AppContext);

  const isEnglish = state.language === UserLanguage.ENGLISH;

  const switchLanguage = (): void => {
    /* istanbul ignore next: tested elsewhere */
    sendTealiumEvent("Header", isEnglish ? "Espanol" : "English");

    dispatch({
      type: ActionType.UPDATE_LANGUAGE,
      payload: isEnglish ? UserLanguage.SPANISH : UserLanguage.ENGLISH,
    });

    const uri = new URI(location.search);
    uri.setQuery(
      "lang",
      isEnglish ? UserLanguage.SPANISH : UserLanguage.ENGLISH
    );
    location.search = uri.search();
    history.replace(location);
  };

  // Translating these two strings is not necessary
  return (
    <Button className={className} onClick={switchLanguage}>
      {isEnglish ? "Español" : "English"}
    </Button>
  );
};

export default withRouter(ToggleLanguageButton);
